import { Reducer } from "redux";

import { UserStatusActionDispatchTypes } from "../constants/MyAccount";
import { UserStatusResponse } from "../models/api/MyAccount";
import { UserStatusDispatchTypes } from "../models/dispatchTypes/MyAccount";

const initialState: UserStatusResponse = {
  loading: false,
  response: "",
  error: null,
};

const UserStatusReducer: Reducer<UserStatusResponse, UserStatusDispatchTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case UserStatusActionDispatchTypes.USER_STATUS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case UserStatusActionDispatchTypes.USER_STATUS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UserStatusActionDispatchTypes.USER_STATUS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case UserStatusActionDispatchTypes.USER_STATUS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UserStatusReducer;
